<script>
	import { handleNav } from "$lib/utilities/handleNav";

	export let data;

	const handleLangSelect = (event) => {
		event.preventDefault();

		handleNav(event);

		// this forces the element to lose focus so the dropdown will close after you move the mouse over
		event.currentTarget.blur();
	};

	$: options = data.languageOptions;
	$: currentOption = data.currentLanguageOption;
</script>

{#if options.length > 1}
	<!-- languages -->
	<li class="my-auto hover-ripple dropdown dropdown-hover dropdown-end">
		<div tabindex="0" role="button" class="flex">
			{#if currentOption?.path}
				<a
					class={`flex whitespace-nowrap`}
					href={`${currentOption?.path}`}
					onClick={handleLangSelect}
					thisLinkFor="languages"
				>
					{currentOption?.option}
					<div>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 24 24"
							width="24"
							height="24"
							fill="currentColor"
						>
							<path d="M6 9l6 6 6-6" />
						</svg>
					</div>
				</a>
			{/if}
		</div>
		<ul class="dropdown-content bg-base-300">
			<div class="px-4">
				{#each options as option}
					<li class="hover-ripple my-4">
						<a
							class={`whitespace-nowrap ${option.class || ""}`}
							onclick={handleLangSelect}
							href={option.path}
						>
							{option.option}
							{option.label}
						</a>
					</li>
				{/each}
			</div>
		</ul>
	</li>
{/if}
